// Contexto de erro HTTP que pode ir pro Better Stack (Sentry SDK).
//
// Nunca mandar o AxiosError inteiro (nem `JSON.stringify(e)`): o `config` leva
// o header `authorization` com o token do Cognito e o `data` da request, que
// num pedido é nome, CPF/CNPJ, e-mail, telefone e endereço do cliente final.
// Daqui sai só o que diz QUAL chamada falhou e COMO.

type MaybeHttpError = {
  name?: string;
  code?: string;
  message?: string;
  config?: { method?: string; url?: string };
  response?: { status?: number; data?: { message?: unknown } };
};

export function httpErrorContext(error: unknown) {
  const e = (error ?? {}) as MaybeHttpError;
  const backendMessage = e.response?.data?.message;
  return {
    error_name: e.name,
    error_code: e.code,
    // Mensagem do erro JS ("Network Error", "timeout of 15000ms exceeded",
    // TypeError de código). A do backend vai em backend_message.
    error_message: e.message,
    method: e.config?.method?.toUpperCase(),
    // Sem query string: busca por documento/e-mail vai na query.
    path: e.config?.url?.split('?')[0],
    status: e.response?.status,
    backend_message:
      typeof backendMessage === 'string'
        ? backendMessage
        : Array.isArray(backendMessage)
          ? backendMessage.filter((m) => typeof m === 'string')
          : undefined,
  };
}
